import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

import { colors } from '../mock-data/sunshade-colors';
import { initSelectedCar } from '../utils/helpers';

const TABS = [
  {
    name: 'Product Information',
    value: 'INFO',
    html: window?.conspire_product?.description
  },
  {
    name: 'Warranty',
    value: 'WARRANTY',
    html: window?.conspire_product_warranty
  },
  {
    name: 'FAQ',
    value: 'FAQ',
    html: window?.conspire_product_faq
  }
];

const INITIAL_STATE = {
  tabs: TABS,
  colors,
  selectedColor: colors[0],
  selectedCar: initSelectedCar(),
  quantity: 1,
  productVariant: {}
};

export const useSunshadeStore = create(
  immer((set) => ({
    ...INITIAL_STATE,
    setSelectedColor: (color) =>
      set((state) => {
        state.selectedColor = color;
      }),
    setSelectedCar: (car) =>
      set((state) => {
        state.selectedCar = car;
      }),
    setQuantity: (quantity) =>
      set((state) => {
        state.quantity = quantity;
      }),
    setProductVariant: (variant) =>
      set((state) => {
        state.productVariant = variant;
      }),
  }))
);
